/*
 *
 * DownloadReport actions
 *
 */

import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  SEARCH_GENERATED_REPORTS,
  UPDATE_TABLE_DATA,
  UPDATE_FILTERS,
  RESET_FILTERS,
  SAVE_REPORTS,
  GET_REPORT_BY_ID,
  HANDLE_GET_REPORT_BY_ID_RESPONSE,
  DOWNLOAD_REPORT,
  HANDLE_DOWNLOAD_REPORT_RESPONSE,
  DELETE_REPORT,
  HANDLE_DELETE_REPORT_RESPONSE,
  GENERATE_REPORT,
  HANDLE_GENERATE_REPORT_RESPONSE,
  RESET_PAGE,
  RESET_MODAL,
  RESET_DATA,
  GET_VENDOR_RECON_REPORT,
  SEARCH_VENDOR_RECON_SETTLEMENT_SPECIFIC_REPORT,
  HANDLE_NEW_REPORT_STATUS,
  GET_VENDOR_ORDER_RECON_REPORT,
  MERCHANT_ROUTES,
  MERCHANT_RETARGET,
  SHARE_REPORT,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function searchGeneratedReportsAction(data) {
  return {
    type: SEARCH_GENERATED_REPORTS,
    data,
  };
}

export function updateTableDataAction(data) {
  return {
    type: UPDATE_TABLE_DATA,
    data,
  };
}

export function updateFiltersAction(data) {
  return {
    type: UPDATE_FILTERS,
    data,
  };
}

export function resetFiltersAction(data) {
  return {
    type: RESET_FILTERS,
    data,
  };
}

export function saveReports(data) {
  return {
    type: SAVE_REPORTS,
    data,
  };
}

export function getReportByIdAction(data) {
  return {
    type: GET_REPORT_BY_ID,
    data,
  };
}

export function handleGetReportByIdResponse(data) {
  return {
    type: HANDLE_GET_REPORT_BY_ID_RESPONSE,
    data,
  };
}

export function downloadReportAction(data) {
  return {
    type: DOWNLOAD_REPORT,
    data,
  };
}

export function handleDownloadReportResponse(data) {
  return {
    type: HANDLE_DOWNLOAD_REPORT_RESPONSE,
    data,
  };
}

export function deleteReportAction(data) {
  return {
    type: DELETE_REPORT,
    data,
  };
}

export function handleDeleteReportResponse(data) {
  return {
    type: HANDLE_DELETE_REPORT_RESPONSE,
    data,
  };
}

export function generateReportAction(data) {
  return {
    type: GENERATE_REPORT,
    data,
  };
}

export function handleGenerateReportResponse(data) {
  return {
    type: HANDLE_GENERATE_REPORT_RESPONSE,
    data,
  };
}

export function resetPageAction() {
  return {
    type: RESET_PAGE,
  };
}

export function resetModalAction() {
  return {
    type: RESET_MODAL,
  };
}

export function resetDataAction() {
  return {
    type: RESET_DATA,
  };
}

export function getVendorReconReportAction(data) {
  return {
    type: GET_VENDOR_RECON_REPORT,
    data,
  };
}

export function searchVendorReconSettlementSpecificReportAction(data) {
  return {
    type: SEARCH_VENDOR_RECON_SETTLEMENT_SPECIFIC_REPORT,
    data,
  };
}

export function handleNewReportStatusAction(data) {
  return {
    type: HANDLE_NEW_REPORT_STATUS,
    data,
  };
}

export function getVendorOrderReconReport(data) {
  return {
    type: GET_VENDOR_ORDER_RECON_REPORT,
    data,
  };
}

export function getMerchantRouteAction(data) {
  return {
    type: MERCHANT_ROUTES,
    data,
  };
}

export function merchantRetargetConfigAction(data) {
  return {
    type: MERCHANT_RETARGET,
    data,
  };
}

export function shareReportAction(data) {
  return {
    type: SHARE_REPORT,
    data,
  };
}
